import * as RA from 'ramda-adjunct'
import type {TRuleset} from '@kapitalist/contract/ruleset'
import type {TGamePlayer} from '@kapitalist/contract/types'
import * as M from '@kapitalist/utils/Map'
import {safelyOr} from '@kapitalist/utils/safely'
import GamePlayer from '~/models/game/GamePlayer'
import type {PlayerGamePosition} from '~/models/game/GamePosition'
import type ExposedHand from '~/models/game/Hands/ExposedHand'
import type MajorAction from '~/models/game/MajorAction'
import type Portfolio from '~/models/game/Portfolio'

/* a player whose hand we can see */
export default class ExposedGamePlayer extends GamePlayer {
  hand: ExposedHand

  constructor(playerData: TGamePlayer, portfolio: Portfolio, hand: ExposedHand) {
    super(playerData, portfolio, hand)
    this.hand = hand
  }

  /*  public availableMovesFromHandByCardId = (
    gameData: GameData,
    rules: TRuleset
  ): Map<string, MajorAction[]> => {
    const obj: {[k: string]: MajorAction[]} = {}
    this.hand.cards.forEach(c => {
      obj[c.id] = RA.ensureArray(
        c.availableMovesFromHand({gameData, portfolio: this.portfolio, rules})
      )
    })

    return M.fromObj<string, MajorAction[]>(obj)
  }*/

  public availableMovesFromHandForCardId = (
    cardId: string,
    rules: TRuleset,
    playerGamePosition: PlayerGamePosition
  ): MajorAction[] =>
    safelyOr(
      this.hand.cards.find(c => c.id === cardId),
      c =>
        RA.ensureArray(
          c.availableMovesFromHand({
            portfolio: this.portfolio,
            rules,
            playerGamePosition,
          })
        ),
      []
    )

  public availableMovesFromTableByCardId = (
    rules: TRuleset,
    playerGamePosition: PlayerGamePosition
  ): Map<string, MajorAction[]> => {
    const obj: {[k: string]: MajorAction[]} = {}
    this.portfolio.allCards().forEach(c => {
      obj[c.id] = RA.ensureArray(
        c.availableMovesFromTable({
          portfolio: this.portfolio,
          rules,
          playerGamePosition,
        })
      )
    })

    return M.fromObj<string, MajorAction[]>(obj)
  }
  /*
  public availableMovesFromTableForCardId = (
    cardId: string,
    gameData: GameData,
    rules: TRuleset
  ): MajorAction[] =>
    safelyOr(
      this.portfolio.allCards().find(c => c.id === cardId),
      c =>
        RA.ensureArray(
          c.availableMovesFromTable({gameData, portfolio: this.portfolio, rules})
        ),
      []
    )*/
}
